<template>
  <div>
    <loading :active.sync="isLoading" color="#64B9B0"></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
         <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/adm/usuarios">Corretores</router-link>
          </li>
          <li class="breadcrumb-item active">Criar Corretor</li>
        </ol> 

        <!-- Dados usuário-->
        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2>
              <i class="fa fa-info-circle"></i>Informações do Corretor
            </h2>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>E-mail</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="corretor.email"
                  @blur="setLogin"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Nome</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder
                  v-model="corretor.name"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Sobrenome</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder
                  v-model="corretor.last_name"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Login</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder
                  readonly
                  v-model="corretor.login"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Senha</label>
                <input
                  type="password"
                  class="form-control"
                  placeholder
                  v-model="corretor.password"
                  autocomplete="new-password"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <p>
                <button href="#0" class="btn_1 medium pull-right" @click="salvaCorretor()">Salvar</button>
              </p>
            </div>
          </div>
        </div>
      </div> <!-- /container-fluid-->
    </div> 
    </div> 
</template>

<script>
import { ajax, tratamento_requisicao, alerta } from "@/utils/util";
import { isEmpty, isEmail, isName } from "@/utils/validate";
import funcoesGerais from "@/assets/js/funcoes.js";
import { VueEditor } from "vue2-editor";
import { Money } from "v-money";
import {Loader, LoaderOptions} from 'google-maps';
import axios from "axios";

export default {
  components: {
    VueEditor,
    Money
  },
  mixins: [funcoesGerais],
  data() {
    return {
      corretor: {},
      id_corretor: this.$route.params.id_corretor,
      isLoading: false,
    };
  },

  mounted() {
    let self = this;
    self.isLoading = true;
    axios.get(`corretores/${self.id_corretor}`)
      .then(response => {
          self.corretor = response.data
          self.isLoading = false;
      }).catch(error => {
          self.isLoading = false;
          tratamento_requisicao(error, this);
      })
  },

  methods: {
    salvaCorretor() {
      let self = this;
      self.isLoading = true;
      const validate = isEmpty(self.corretor);
      const emailValidate = isEmail(self.corretor.email);
      const nameValidate = isName(self.corretor.name);
      const lastNameValidate = isName(self.corretor.last_name);

      if (validate && emailValidate && nameValidate && lastNameValidate) {
        if(!self.corretor.password) delete self.corretor.password;
        ajax("put", `corretores/${self.id_corretor}`,self.corretor)
          .then(response => {
            self.isLoading = false;
            alerta(
              "success",
              "Sucesso",
              "Corretor alterado com sucesso!"
            );
            self.$router.replace(this.$route.query.redirect || "/uniodonto/corretores");
          })
          .catch(error => {
            self.isLoading = false;
            tratamento_requisicao(error, this);
          });
      } else {
        let text = "";
        if (!validate) text = "Campos obrigatórios não preenchidos."
        else if (!emailValidate) text = "Email inválido."
        else if (!nameValidate || !lastNameValidate) text = "Nome e sobrenome não devem conter números ou caracteres especiais."
        alerta("warning", "Aviso", text);
        self.isLoading = false;
      }
    },

    setLogin() {
      this.corretor.login = this.corretor.email;
    }
  },
};
</script>

<style scoped>
.input-horario {
  width: 50px;
  border: blue;
}

#map{
  width: 100%;
}

</style>